import { ButtonType } from '../../modal/button.handler';
import { InitButton } from '../../modal/modal.button';
import { ModalHandler } from '../../modal/modal.handler';

export function reloadHandler(): ModalHandler {
   const handler: ModalHandler = new ModalHandler();
   handler.title = 'Upgrade available.';
   handler.text = 'Do you want to reload the page to upgrade?';
   [handler.buttons] = InitButton({ type: ButtonType.OkCancel, prefix: 'reload' }, 1);
   handler.keyboard = false;
   handler.ignoreBackdropClick = true;
   handler.closeButton = false;
   return handler;
}
